export default __webpack_public_path__ + "static/media/ProgressStage7.0ea39291.svg";